export default __webpack_public_path__ + "static/media/left_hero.280071ce.png";